/**
 * Copyright © 2020-21 Robert Bosch Engineering and Business Solutions Private Limited. All Rights Reserved.
   NOTICE:  All information contained herein is, and remains the property of Robert Bosch Engineering and Business Solutions Private
   Limited. Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is
   obtained from Robert Bosch Engineering and Business Solutions Private Limited.
*/

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CanAuthenticationGuard } from '../providers/auth-guard';
import { CreateDeviceComponent } from './create-device/create-device.component';
import { ManageDeviceComponent } from './manage-device/manage-device.component';
import { CreateGroupComponent } from './create-group/create-group.component';
import { ManageGroupComponent } from './manage-group/manage-group.component';
import { ConfigureDeviceComponent } from './configure-device/configure-device.component';
import { GroupDetailsComponent } from './group-details/group-details.component';
import { DeviceTunnelingComponent } from './device-tunneling/device-tunneling.component';
import { DeviceSimMappingComponent } from './device-sim-mapping/device-sim-mapping.component';
import { DeviceStatisticsComponent } from './device-statistics/device-statistics.component';
import { SystemApplicationGraphsComponent } from './system-application-graphs/system-application-graphs.component';
import { C2dMethodComponent } from './c2d-method/c2d-method.component';
import { ApplicationGraphsComponent } from './application-graphs/application-graphs.component';
/**
  * @ngdoc overview
  * @name MODULE_NAME.module:DevicesModule
  *
  * @description
  * description: To route to different components in devices module based on the path given
*/
const routes: Routes = [
  {
    path: 'devices/create-devices',
    component: CreateDeviceComponent,
    canActivate: [CanAuthenticationGuard],
    data: { permission: 'IND_EN_C', data: {}}
  },
  {
    path: 'devices/create-groups',
    component: CreateGroupComponent,
    canActivate: [CanAuthenticationGuard],
    data: { permission: 'GRP_EN_C', data: {}}
  },
  {
    path: 'devices/manage-devices',
    component: ManageDeviceComponent,
    canActivate: [CanAuthenticationGuard],
    data: { permission: 'IND_EN_R', data: {}}
  },
  {
    path: 'devices/manage-groups',
    component: ManageGroupComponent,
    canActivate: [CanAuthenticationGuard],
    data: { permission: 'GRP_EN_R', data: {}}
  },
  {
    path: 'configure-devices',
    component: ConfigureDeviceComponent,
    canActivate: [CanAuthenticationGuard],
    data: { permission: 'DES_PROP_R', data: {}}
  },
  {
    path: 'group-details',
    component: GroupDetailsComponent,
    canActivate: [CanAuthenticationGuard],
    data: { permission: 'GRP_EN_C', data: {}}
  },
  {
    path: 'device-tunneling',
    component: DeviceTunnelingComponent,
    canActivate: [CanAuthenticationGuard],
    data: { permission: 'DEV_TUNN_CLL', data: {}}
  },
  {
    path: 'devices/mapping',
    component: DeviceSimMappingComponent,
    canActivate: [CanAuthenticationGuard],
    data: { permission: 'DEV_SIM_LNK_C', data: {}}
  },
  {
    path: 'device-statistics',
    component: DeviceStatisticsComponent,
    canActivate: [CanAuthenticationGuard],
    data: { permission: 'DEV_MTD_CLL', data: {}}
  },
  {
    path: 'system-application-graphs',
    component: SystemApplicationGraphsComponent,
    canActivate: [CanAuthenticationGuard],
    data: { permission: 'DEV_MTD_CLL', data: {}}
  },
  {
    path: 'c2d-method',
    component: C2dMethodComponent,
    canActivate: [CanAuthenticationGuard],
    data: { permission: 'DEV_MTD_CLL', data: {}}
    
  }, {
    path: 'application-graphs',
    component: ApplicationGraphsComponent,
    canActivate: [CanAuthenticationGuard],
    data: { permission: 'DEV_MTD_CLL', data: {}}
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DevicesRoutingModule { }
